import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'lib-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  public body: string | string[];
  public isArray: boolean;
  public confirmText: string;
  public cancelText: string;
  public confirmBtnClass = '';

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.body = this.dynamicDialogConfig?.data?.body;
    this.isArray = Array.isArray(this.body);
    this.confirmBtnClass = this.dynamicDialogConfig?.data?.confirmBtnClass ? this.dynamicDialogConfig?.data?.confirmBtnClass : '';
    this.confirmText = 'Confirm';
    this.cancelText = 'Cancel';
  }

  ngOnInit(): void {
  }

  confirm(): void {
    this.dynamicDialogRef.close(true);
  }

  cancel(): void {
    this.dynamicDialogRef.destroy();
  }
}
